import React from 'react';
import ContentPage from '../ContentPage/ContentPage';

const TermsPage: React.FC = () => <ContentPage slug="agb" title="AGB" />;

export default TermsPage;
